import { get, merge, set, union, pull, indexOf } from 'lodash';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import Worksheet from '../../../../common/components/Worksheet';
import JobRequestDetails from './Details';
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import RouteTransitionBlocker from '../../../r_ApplicantDashboard/f_RouteTransitionBlocker';
import TackIcon from '../../../../common/svgs/TackIcon';

import { convertEmployeeToMenuItems, JOB_REQUEST_STATUS } from '../../../../redux/helpers/staticData';
import * as jobrequestsAdminApi from   '../../../../redux/actionCreators/async/jobrequestsAdmin';
import * as jobrequestsApi from   '../../../../redux/actionCreators/async/jobrequests';
import * as jobrequestsAdminStore from '../../../../redux/actionCreators/sync/jobrequestsAdmin';
import * as ui from '../../../../redux/actionCreators/sync/ui';
import { loadPins } from '../../../../redux/actionCreators/sync';
import { updatePins, getUsersByRole } from '../../../../redux/actionCreators/async/employees';

@connect((state) => {
  return {
    staticData: state.staticData,
    jobRequest: state.jobRequest,
    primaryContact: state.companyContacts.find((contact) => contact.profile.id === state.jobRequest.primaryContactId),
    pinnedData: get(state, 'pins.pinned', {})
  };
})

export default class JobRequestWorksheet extends Component {

  static propTypes = {
    jobRequest: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    primaryContact: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    jobId: PropTypes.number.isRequired,
    children: PropTypes.object.isRequired
  };


  constructor(props) {
    super(props);

    this.state = {
      showSaved: false,
      showTransitionBlocker: false,
      menuItems: {}
    };

  }

  componentDidMount() {
    const getEmployeesByRole = (role) => this.props.dispatch(getUsersByRole(role));

    getEmployeesByRole('Placement Specialist')
     .then((rEmployees) => {

         const placementSpecialists = convertEmployeeToMenuItems(rEmployees);
         const clonedState = merge({}, this.state, {menuItems: { placementSpecialists }});

         this.setState(clonedState);
     });
  }

  handleSave = (request) => {
    const updateJobRequest = this.props.dispatch(jobrequestsAdminApi.updateJobRequest(request.jobrequest.id, request));
    const updateJobRequestStore = (data) => this.props.dispatch(jobrequestsAdminStore.updateJobRequest(data));

    const updatedJobRequest = merge({}, this.props.jobRequest, request.jobrequest);

    return updateJobRequest
        .then(() => updateJobRequestStore(updatedJobRequest)).then(() => {
          this.setState({showSaved: true});
          this.props.dispatch(ui.showSnackBar('Job request has been updated'));
        });

  }

  handleDelete = () => {
    const deleteJobRequest = this.props.dispatch(jobrequestsApi.deleteJobRequest(this.props.jobRequest.id));

    return deleteJobRequest
      .then(() => {
        this.props.dispatch(ui.showSnackBar('Job request has been deleted'));
        this.props.dispatch(goBack());
      })
    ;
  }

  handleUpdateStatus = (request) => {

    if (request.jobrequest.jobRequestStatus && request.jobrequest.jobRequestStatus === JOB_REQUEST_STATUS.APPROVED_REQUEST) {
      // check if there's a placement specialist
      if (!this.props.jobRequest.placementSpecialistId) {
        // show placement specialist modal
        this.setState({showTransitionBlocker: true})
        return;
      }
    }

    const updateJobRequestStore = (data) => this.props.dispatch(jobrequestsAdminStore.updateJobRequest(data));

    this.props.dispatch(jobrequestsAdminApi.updateJobRequestStatus(request.jobrequest.id, request.jobrequest.jobRequestStatus))
      .then(() => updateJobRequestStore(request.jobrequest))
      .then(() => {
        this.setState({showSaved: true});
      });
  }

  handlePlacementChange = (event, value) => {
    this.setState({placementSpecialistId: value});
  }

  handlePlacementUpdate = (event) => {
    if (this.state.placementSpecialistId) {
      const jobRequest = {id: this.props.jobRequest.id, jobRequestStatus: JOB_REQUEST_STATUS.APPROVED_REQUEST, placementSpecialistId: this.state.placementSpecialistId};
      this.handleSave({jobrequest: jobRequest})
        .then(() => this.handleUpdateStatus({jobrequest: jobRequest}));

      this.setState({showTransitionBlocker: false})
    }
  }

  // pin functions
  isPinned = () => {
    return indexOf(get(this.props.pinnedData, 'jobRequests', []), this.props.jobRequest.id) >= 0;
  }

  handleTogglePin = () => {
    return () => {
      let newPinnedData = this.props.pinnedData;
      if (this.isPinned()) {
        pull(newPinnedData.jobRequests, this.props.jobRequest.id)
      }
      else {
        set(newPinnedData, 'jobRequests', union(get(newPinnedData, 'jobRequests', []), [this.props.jobRequest.id]));
      }

      this.props.dispatch(updatePins(newPinnedData, (err, pins) => {
        if (!err) {
          this.props.dispatch(loadPins(pins))}
        }
      ));
    }
  }

  render() {
    const {
      primaryContact = null,
    } = this.props;

    const placementSpecialistDropdown =
    (<DropDownMenu
      className='transition-placement-dropdown'
      data-id='transition-placement-dropdown'
      menuItems={get(this.state, 'menuItems.placementSpecialists', [])}
      onChange={this.handlePlacementChange}
    />);

    const pin = <div className='pin' onClick={this.handleTogglePin()}> <TackIcon /> <span className='pin-text'>{this.isPinned() ? 'unpin' : 'pin'}</span></div>;

    return (
      <Worksheet
        baseRoute='/admin/jobrequests'
        dispatch={this.props.dispatch}
        location={this.props.location}
        pin={pin}
        className='job-request-worksheet'
        >

        <div key='Card'>
          <JobRequestDetails jobId={this.props.jobId} handleSave={this.handleSave} handleUpdateStatus={this.handleUpdateStatus} handleDelete={this.handleDelete} />
        </div>

        {
          this.state.showTransitionBlocker
            &&
          <RouteTransitionBlocker
            primaryAction={this.handlePlacementUpdate}
            primaryButtonLabel='Save'
            secondaryAction={(e) => this.setState({showTransitionBlocker: false})}
            secondaryButtonLabel='Cancel'
            cancelAction={(e) => this.setState({showTransitionBlocker: false})}
            control={placementSpecialistDropdown}
            transitionText={'You have not selected a placement specialist. <br />Please select one before changing the job request status to approved.'}
            className={'jobrequest-approve'}
          />
        }

        {React.cloneElement(this.props.children, { handleSave: this.handleSave, jobRequest: this.props.jobRequest, primaryContact})}
      </Worksheet>
    );

  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/index.js